import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
`;

export const Container = styled.div`
  border-radius: 1.2rem;
  overflow: hidden;
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  margin-bottom: 1.2rem;
  background-color: ${({ theme }) => theme.colors.surfaceSoft};
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  gap: 1.2rem;
`;

export const MicIcon = styled.div`
  font-size: 3.2rem;
`;

export const Hint = styled.div`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.slateGrey};
`;

export const Canvas = styled.canvas`
  border-radius: 0.8rem;
`;

export const RecordingDot = styled.div`
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 0.6rem;
  background-color: ${({ theme }) => theme.colors.errorRed};
  animation: ${pulse} 1s ease-in-out infinite;
`;

export const Timer = styled.div`
  font-size: 1.8rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
  font-variant-numeric: tabular-nums;
`;

export const Audio = styled.audio`
  width: 100%;
  max-width: 28rem;
`;

export const Row = styled.div`
  display: flex;
  gap: 0.8rem;
  width: 100%;
`;

export const PrimaryBtn = styled.button`
  flex: 1;
  padding: 1rem 1.6rem;
  border-radius: 1rem;
  border: none;
  background-color: ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.white};
  font-size: 1.4rem;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
`;

export const CancelBtn = styled.button`
  flex: 1;
  padding: 1rem 1.6rem;
  border-radius: 1rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.slateGrey};
  font-size: 1.4rem;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
`;

export const StopBtn = styled.button`
  padding: 1rem 2.4rem;
  border-radius: 1rem;
  border: none;
  background-color: ${({ theme }) => theme.colors.errorRed};
  color: ${({ theme }) => theme.colors.white};
  font-size: 1.4rem;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
`;

export const ErrorText = styled.div`
  color: ${({ theme }) => theme.colors.errorRed};
  font-size: 1.3rem;
  text-align: center;
  padding: 2rem;
`;
